import { render } from "./index.vue?vue&type=template&id=727a1d26&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=727a1d26&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-727a1d26"

export default script